<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">如果是，请提供详情</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		schema() {
			return [
				{
					label: `您曾否吸食任何形式的烟草或尼古丁产品（包括香烟、雪茄、小雪茄、烟斗、嚼烟、尼古丁贴片 或尼古丁香口糖）? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProductCN`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProductCN`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProductCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaList(i) {
			return [
				{
					label: `产品`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoProduct${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoProduct${i}CN`
						},
						createOptions: {
							type: `tobaccoProduct${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `数量／频密度`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoFrequency${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoFrequency${i}CN`
						},
						createOptions: {
							type: `tobaccoFrequency${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上次使用日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoDateLastUsed${i}CN`,
					props: {
						suggest: {
							typeIncludes: `tobaccoDateLastUsed${i}CN`
						},
						createOptions: {
							type: `tobaccoDateLastUsed${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
